import {Pipe, PipeTransform} from '@angular/core';
import {Group} from "../../../domain/models";

@Pipe({
  name: 'filterGroups'
})
export class FilterGroupsPipe implements PipeTransform {

  transform(items: Group[], searchText: string): unknown {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter(it => {
      return it.name.toLowerCase().includes(searchText) || it.id.toLowerCase().includes(searchText) || it.value.toLowerCase().includes(searchText);
    });
  }

}
